import { DropdownButtonContext } from '@dixa/lib-shared-habla';
import { memo, useContext } from 'react';
import { useMount } from 'react-use';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import {
  CopilotTrialStatus,
  useCopilotTrial,
} from '../../../../utils/useCopilotTrial';

/**
 * Represents a component that opens feedback modal on mount and then closes its
 * parent dropdown
 */
export const EditorCopilotDropdownFeedback = memo(
  function EditorCopilotDropdownFeedback() {
    const dropdownContext = useContext(DropdownButtonContext);
    const dispatch = useAppDispatch();

    const { status } = useCopilotTrial();

    useMount(() => {
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:feedbackForm',
            arg: {
              title: 'AI Co-pilot feedback',
              team: 'conversations',
              placeholder: "Tell us what's on your mind.",
              ...(status === CopilotTrialStatus.TrialActive && {
                feature: 'copilotTrial',
              }),
            },
          },
        }),
      );

      dropdownContext.closeDropdown();
    });

    return null;
  },
);
